export default __webpack_public_path__ + "static/media/invoice_payment_paid.78a40287.svg";